import { Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ProjectStatisticUnavailableCardProps {
    title: string;
}

export function ProjectStatisticUnavailableCard({ title }: ProjectStatisticUnavailableCardProps) {
    const { t } = useTranslation("project");

    return (
        <Paper sx={{ p: 3 }} variant="outlined">
            <Typography variant="h6" gutterBottom>
                {title}
            </Typography>
            <Typography color="text.secondary">{t("overviewScreen.emptyStatistic")}</Typography>
        </Paper>
    );
}
